// src/pages/work-order-management-system/components/api/pdfApi.js

// ✅ Usa VITE_API_BASE o VITE_API_URL (por si en Vercel usaste otro nombre)
const RAW_BASE = import.meta.env.VITE_API_BASE || import.meta.env.VITE_API_URL || '';
const API_BASE = RAW_BASE.replace(/\/+$/, '');

// ✅ Normaliza para que siempre termine en /api (sin duplicar)
const API_ROOT = API_BASE.endsWith('/api') ? API_BASE : `${API_BASE}/api`;

// ✅ Endpoint real
const PDF_ENDPOINT = `${API_ROOT}/pdfs`;

console.log('[API] PDF_ENDPOINT =>', PDF_ENDPOINT);

const safeJson = async (res) => {
    try {
        return await res.json();
    } catch {
        return null;
    }
};

export async function savePdf(record) {
    if (!record?.id || !record?.name || !record?.type) {
        throw new Error('savePdf: faltan campos obligatorios (id, name, type)');
    }

    const res = await fetch(PDF_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(record),
    });

    const json = await safeJson(res);

    if (!res.ok) {
        const msg =
            json?.error ||
            json?.message ||
            (await res.text().catch(() => '')) ||
            `HTTP ${res.status}`;

        // ✅ muestra la URL real (no “/api/pdfs” hardcodeado)
        throw new Error(`POST ${PDF_ENDPOINT} failed: ${res.status} ${msg}`);
    }

    return json?.data ?? json;
}
